<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        class="py-0"
      >
        <span> Is Employee EPF Contribute? </span>
        <v-radio-group
          v-model="isEmployeeEpfContribute"
          class="mt-2"
          row
          @change="employeeContributionDeduction = null; employeeCustomizedRate = null; employeeCustomizedAmount = 0;"
        >
          <v-radio
            label="No"
            :value="0"
          />
          <v-radio
            label="Yes"
            :value="1"
          /> 
        </v-radio-group>
      </v-col>

      <v-col
        v-if="isEmployeeEpfContribute"
        class="py-0"
      >
        <v-autocomplete
          v-model="employeeEpfContributionType"
          v-validate="isEmployeeEpfContribute ? 'required' : ''"
          label="Employee EPF Contribution Type"
          :error-messages="errors.collect('employeeEpfContributionType')"
          data-vv-name="employeeEpfContributionType"
          data-vv-as="employee EPF contribution type"
          clearable
          item-value="id"
          item-text="name"
          :items="epfContributionCategories"
          outlined
        />
      </v-col>
                      
      <v-col
        v-if="isEmployeeEpfContribute && employeeEpfContributionType === 1"
        cols="12"
        class="py-0"
      >
        <v-autocomplete
          v-model="employeeContributionDeduction"
          v-validate="employeeEpfContributionType === 1 ? 'required' : ''"
          label="Employee Epf Rate (Follow Government)"
          :error-messages="errors.collect('employeeContributionDeduction')"
          data-vv-name="employeeContributionDeduction"
          data-vv-as="employee follow government epf rate"
          clearable
          item-value="id"
          :item-text="item => '['+item.code+'] - '+ item.name"
          :items="contributionDeductions"
          outlined
          @change="employeeCustomizedRate = null; employeeCustomizedAmount = 0; employerContributionDeduction = employeeContributionDeduction"
        />
      </v-col>
      
      <v-col
        v-if="isEmployeeEpfContribute && employeeEpfContributionType === 2"
        cols="12"
        class="py-0"
      >
        <v-text-field
          v-model="employeeCustomizedRate"
          v-validate="employeeEpfContributionType === 2 ? 'required|oneDecimalValue|pointFive|min_value:0|max_value:100' : ''"
          :error-messages="errors.collect('employeeCustomizedRate')"
          data-vv-name="employeeCustomizedRate"
          data-vv-as="employee customized EPF rate"
          label="Employee Customized EPF Rate"
          type="number"
          suffix="%"
          clearable
          outlined
          :min="0"
          :max="100"
          @keydown.native="['e', 'E', '+', '-'].includes($event.key) && $event.preventDefault()"
          @change="employeeContributionDeduction = null; employeeCustomizedAmount = 0;"
        />
      </v-col>

      <v-col
        v-if="isEmployeeEpfContribute && employeeEpfContributionType === 3"
        cols="12"
        class="py-0"
      >
        <v-text-field
          v-model="employeeCustomizedAmount"
          v-validate="employeeEpfContributionType === 3 ? 'required' : ''"
          v-money="money"
          :error-messages="errors.collect('employeeCustomizedAmount')"
          data-vv-name="employeeCustomizedAmount"
          data-vv-as="employee customized EPF amount"
          label="Employee Customized EPF Amount"
          prefix="RM"
          outlined
          @change="employeeContributionDeduction = null; employeeCustomizedRate = null;"
        />
      </v-col>
      <v-col
        cols="12"
        class="py-0"
      >
        <span> Is Employer EPF Contribute? </span>
        <v-radio-group
          v-model="isEmployerEpfContribute"
          class="mt-2"
          row
          @change="employeeContributionDeduction = null; employeeCustomizedRate = null"
        >
          <v-radio
            label="No"
            :value="0"
          />
          <v-radio
            label="Yes"
            :value="1"
          /> 
        </v-radio-group>
      </v-col>

      <v-col
        v-if="isEmployerEpfContribute"
        class="py-0"
      >
        <v-autocomplete
          v-model="employerEpfContributionType"
          v-validate="isEmployerEpfContribute ? 'required' : ''"
          label="Employer EPF Contribution Type"
          :error-messages="errors.collect('employerEpfContributionType')"
          data-vv-name="employerEpfContributionType"
          data-vv-as="employer EPF contribution type"
          clearable
          item-value="id"
          item-text="name"
          :items="epfContributionCategories"
          outlined
        />
      </v-col>

      <v-col
        v-if="isEmployerEpfContribute && employerEpfContributionType === 1"
        cols="12"
        class="py-0"
      >
        <v-autocomplete
          v-model="employerContributionDeduction"
          v-validate="employerEpfContributionType === 1 ? 'required' : ''"
          label="Employer Epf Rate (Follow Government)"
          :error-messages="errors.collect('employerContributionDeduction')"
          data-vv-name="employerContributionDeduction"
          data-vv-as="employer follow government epf rate"
          clearable
          item-value="id"
          :item-text="item => '['+item.code+'] - '+ item.name"
          :items="filteredContributionDeductions"
          outlined
          @change="employerCustomizedRate = null; employerCustomizedAmount = 0;"
        />
      </v-col>

      <v-col
        v-if="isEmployerEpfContribute && employerEpfContributionType === 2"
        cols="12"
        class="py-0"
      >
        <v-text-field
          v-model="employerCustomizedRate"
          v-validate="employerEpfContributionType === 2 ? 'required|oneDecimalValue|pointFive|min_value:0|max_value:100' : ''"
          :error-messages="errors.collect('employerCustomizedRate')"
          data-vv-name="employerCustomizedRate"
          data-vv-as="employer customized EPF rate"
          label="Employer Customized EPF Rate"
          type="number"
          suffix="%"
          clearable
          outlined
          :min="0"
          :max="100"
          @keydown.native="['e', 'E', '+', '-'].includes($event.key) && $event.preventDefault()"
          @change="employerContributionDeduction = null; employerCustomizedAmount = 0;"
        />
      </v-col>

      <v-col
        v-if="isEmployerEpfContribute && employerEpfContributionType === 3"
        cols="12"
        class="py-0"
      >
        <v-text-field
          v-model="employerCustomizedAmount"
          v-validate="employerEpfContributionType === 3 ? 'required' : ''"
          v-money="money"
          :error-messages="errors.collect('employerCustomizedAmount')"
          data-vv-name="employerCustomizedAmount"
          data-vv-as="employer customized EPF amount"
          label="Employer Customized EPF Amount"
          prefix="RM"
          outlined
          @change="employerContributionDeduction = null; employerCustomizedRate = null;"
        />
      </v-col>

      <v-col
        cols="12"
        class="py-0"
      >
        <v-menu
          v-model="startDateMenu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="290px"
          max-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="startDateDisplay"
              v-validate="'required'"
              :error-messages="errors.collect('startDateDisplay')"
              data-vv-name="startDateDisplay"
              data-vv-as="start date"
              label="Start date"
              readonly
              outlined
              class="label-position"
              v-on="on"
            >
              <template v-slot:prepend-inner>
                <v-icon>
                  mdi-calendar
                </v-icon>
              </template>
            </v-text-field>
          </template>
          <v-date-picker
            v-model="startDate"
            type="month"
            :min="$moment().subtract(1, 'months').format('YYYY-MM')"
            no-title
            @input="startDateMenu = false"
          />
        </v-menu>
      </v-col>
    </v-row>

    <v-card-actions>
      <v-spacer />
      <v-btn
        :disabled="progressing"
        text
        class="px-10"
        @click="closeDialog"
      >
        Close
      </v-btn>
      <v-btn
        :loading="progressing"
        color="hrissecondary"    
        class="white--text px-10"         
        @click="submitForm"
      >
        submit
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
  import Big from 'big.js'
  import { VMoney } from 'v-money'
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    directives: { money: VMoney },
    props: {
      companyEmployeeUid: {
        type: String,
        default: null,
      },
    },
    data () {
      return {
        startDateMenu: false,
        startDate: null,
        progressing: false,
        contributionDeductions: [],
        employeeContributionDeduction: null,
        employeeCustomizedRate: null,
        employeeCustomizedAmount: null,
        employerContributionDeduction: null,
        employerCustomizedRate: null,
        employerCustomizedAmount: null,
        isEmployeeEpfContribute: 1,
        isEmployerEpfContribute: 1,
        employeeEpfContributionType: 1,
        employerEpfContributionType: 1,
        epfContributionCategories: [
          { id: 1, name: 'Follow Government' },
          { id: 2, name: 'By Custom Rate (%)' },
          { id: 3, name: 'By Custom Amount (RM)' },
        ],
        money: {
          decimal: '.',
          thousands: ',',
          precision: 2,
          masked: false, /* doesn't work with directive */
        },
      }
    },
    computed: {
      startDateDisplay () {
        return this.startDate ? this.$moment(this.startDate + '-01', 'YYYY-MM-DD').format('MMM YYYY') : ''
      },

      filteredContributionDeductions () {
        if (!this.employeeContributionDeduction) return this.contributionDeductions

        return this.contributionDeductions.filter(contributionDeduction => {
          return contributionDeduction.id === this.employeeContributionDeduction
        })
      },
    },
    created () {
      let _this = this

      this.$validator.extend('oneDecimalValue', {
        getMessage (field, args) {
          return 'Only 1 decimal alloweds'
        },
        validate (value, args) {
          return _this.isValidNumbers(value)
        },
      })

      this.$validator.extend('pointFive', {
        getMessage (field, args) {
          return 'Only 0.5 is allowed'
        },
        validate (value, args) {
          if (value.toString().indexOf('.') > -1) {
            let arr = [...value.split('.')[1]]
            return arr[0] === '5' || arr[0] === '0'
          } else {
            return true
          }
        },
      })

      this.$api.contributionDeductions().list('?with=epf')
        .then(res => {
          this.contributionDeductions = res.data
        })
    },
    methods: {
      submitForm () {
        this.$validator.resume()
        this.$validator.validateAll()
          .then(result => {
            if (!result) return
            this.setProgressing(true)

            this.$api.companyEmployeeEpfContributions().create(this.companyEmployeeUid, this.prepareFormData())
              .then(res => {
                this.$emit('created')
                this.$snack({ message: res.data.status })
                
                this.$validator.pause()
                this.clearData()
                this.setProgressing(false)
              })
              .catch((err) => {
                if (err.response.status === 422) {              
                  this.$snack({ 
                    color: 'error',
                    message: err.response.data.status, 
                  })
                }            
            
                this.progressing = false
              })
          })
      },
      closeDialog () {
        this.$emit('close-dialog')
      },
      prepareFormData () {
        return {
          employee_contribution_deduction_id: this.employeeEpfContributionType === 1 ? this.employeeContributionDeduction : null,
          employee_customized_rate: this.employeeEpfContributionType === 2 ? this.employeeCustomizedRate : null,
          employee_customized_amount: this.employeeEpfContributionType === 3 ? this.employeeCustomizedAmount.toString().replaceAll(',', '') : 0,
          employer_contribution_deduction_id: this.employerEpfContributionType === 1 ? this.employerContributionDeduction : null,
          employer_customized_rate: this.employerEpfContributionType === 2 ? this.employerCustomizedRate : null,
          employer_customized_amount: this.employerEpfContributionType === 3 ? this.employerCustomizedAmount.toString().replaceAll(',', '') : 0,
          start_date: this.startDate + '-01',
          is_employee_contributed: this.isEmployeeEpfContribute,
          is_employer_contributed: this.isEmployerEpfContribute,
        }
      },
      setProgressing (status) {
        this.progressing = status
      },
      isValidNumbers (value) {
        return (new Big(value).times(1000) % 100 === 0)
      },
      clearData () {
        this.employeeContributionDeduction = null
        this.employeeCustomizedRate = null
        this.employeeCustomizedAmount = 0
        this.employerContributionDeduction = null
        this.employerCustomizedRate = null
        this.employerCustomizedAmount = 0
      },
    },
  }
</script>

<style scoped>
.label-position >>> .v-label.v-label--active{
  margin-left:-28px;
  background:white;
  padding-right:4px
}
</style>
